import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '@/store'
import iView from 'iview'

Vue.use(Router)

const router = new Router({
  routes,
  mode: 'history',
  base: '/finance/'
})

const whiteList = [
  '/reset-password',
  '/login'
  // '/finance/finance-query',
  // '/finance/finance-detail'
]

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  loginAuth(to, from, next)
})
function loginAuth (to, from, next) {
  const notNeedAuth = whiteList.indexOf(to.path) > -1
  if (notNeedAuth) {
    next()
  } else {
    // 需要登录
    if (store.state.hasLogin) {
      next()
    } else {
      store.dispatch('getInfo').then((data) => {
        next()
      })
    }
  }
}
router.afterEach(to => {
  // setTitle(to, router.app)
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router